import { Box, styled } from '@withjoy/joykit';
import type { StyleSystemProps } from '@withjoy/joykit';
import { ReactComponent as JoyLogo } from '@assets/joy-logo-footer.svg';
import { ParticleJoyLogo } from '@shared/components/ParticleJoyLogo';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledFooterWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(19)};
`;

export const getLinkStyles = (linkColor: string = 'mono10', linkHoverColor: string = 'mono14'): StyleSystemProps => ({
  typographyVariant: 'label3',
  textDecoration: 'none',
  color: linkColor,
  letterSpacing: '-0.03em',
  fontWeight: 'normal',
  _visited: {
    color: linkColor,
  },
  _active: {
    color: linkColor,
  },
  _hover: {
    color: linkHoverColor,
  },
});

export const StyledJoyLogo = styled(JoyLogo)`
  margin: 0 32px 0 32px;
`;

export const alohaFooterContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: { _: 0, sm2: 7 },
  marginTop: { _: 6, sm2: 0 },
  marginBottom: 8,
};

export const brannanFooterContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: { _: 6, sm2: 10 },
  marginBottom: 8,
};

export const StyledParticleJoyLogo = styled(ParticleJoyLogo)`
  & > div {
    & > svg {
      width: 54px;
    }
    & > div > canvas {
      width: 56px;
    }
  }
`;
